export { default } from '@/shared/components/ThemeSwitch';
